import ApiRequest from '@/plugins/axios'

export default {
  analyze (layerId) {
    return ApiRequest.post('import/analyze', { layerId })
  },
  import (data) {
    return ApiRequest.post('import/import', {
      fileConfiguration: data.fileConfiguration,
      layerConfiguration: data.layerConfiguration,
      objectRights: data.objectRights,
      flaechenIdField: data.flaechenIdField,
      updateObjects: data.updateObjects,
      layerId: data.selectedLayer.id
    })
  }
}
